export default function Member($resource, ENV) {
  'ngInject';

  return $resource(
    `${ENV.apiUrl}/pingsta/members/:memberId.json`,
    {},
    {
      query:  {
        method: 'GET',
        isArray: false
      },
      map:  {
        method: 'GET',
        isArray: false,
        url: `${ENV.apiUrl}/pingsta/members/map.json`,
      },
    }
  );
}



// WEBPACK FOOTER //
// ./src/app/screens/engineer/screens/members/util/member.factory.js